import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import { middleware as contentSliceMiddleware, contentSlice} from "./reducers/contentSlice";
import { middleware as userSliceMiddleware, userSlice} from "./reducers/userSlice";
import { middleware as commonMiddleware, commonSlice } from "./reducers/common";
import { middleware as userDataMiddleware, userDataSlice } from "./reducers/userDataSlice";

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

//Deve ser declarado todos os reduces
type ContentSlice = ReturnType<typeof contentSlice.reducer>;
type Userslice = ReturnType<typeof userSlice.reducer>;
type UserDataSlice = ReturnType<typeof userDataSlice.reducer>;

export const Store = configureStore({
  reducer: 
  {
    commonState: commonSlice.reducer,
    contentState: persistReducer<ContentSlice>(
      { key: "content", storage },
      contentSlice.reducer
    ),
    userState: persistReducer<Userslice>(
      { key: "user", storage },
      userSlice.reducer
    ),
    userDataState: persistReducer<UserDataSlice>(
      { key: "userData", storage },
      userDataSlice.reducer
    ),
  },
  
  ///Deve registar todos os middlewares
  middleware: (mm) =>
    mm({
      serializableCheck: false,
    })
      .concat(contentSliceMiddleware)
      .concat(userSliceMiddleware)
      .concat(commonMiddleware)
      .concat(userDataMiddleware)
});

export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const PersitorState = {
  initialized:false
}
export const persistor = persistStore(Store, null, ()=> {
  PersitorState.initialized = true;
}
  );